import React from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { LinkSquare01Icon } from "@hugeicons/core-free-icons";

type Props = {
  size?: number;
  className?: string;
  title?: string;
};

export default function ExternalShareIcon({ size = 18, className, title }: Props) {
  return (
    <span className={className} aria-hidden="true" title={title}>
      <HugeiconsIcon icon={LinkSquare01Icon} size={size} color="currentColor" strokeWidth={1.5} />
    </span>
  );
}

